import { css } from '@emotion/react'
import { Col, Row, Title } from 'common-components'
import { Space } from 'antd'

const Header = () => {
  const texts = [
    {
      type: 'tablePageTitle',
      content: 'Certifications',
    },
    {
      type: 'tablePageSubtitle',
      content: 'Obtenez des Certifications pour débloquer des projets',
    },
  ]

  return (
    // @ts-ignore
    <div>
      <Row
        justify={'space-between'}
        align={'top'}
        css={css`
          margin: 24px 0;
        `}
      >
        <Col>
          <Row justify={'center'} gutter={30} align={'middle'}>
            <Col>
              {texts.map((text, index) => {
                if (index === 0) {
                  return (
                    <Space align={'center'}>
                      <Title key={`title-${text.content}-${index}`} style={{ fontSize: 18 }}>
                        {text.content}
                      </Title>
                    </Space>
                  )
                }
                return (
                  <Title key={`title-${text.content}-${index}`} preset={text.type as any}>
                    {text.content}
                  </Title>
                )
              })}
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default Header
